import axios from 'axios';

const BASE_URL = '/api/billing-reconciliation';
const encoded = (value) => encodeURIComponent(String(value));
const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
);

export const resetBillingReconciliationVarianceReviews = async ({
  runId,
  varianceIds = [],
  bacs = [],
  all,
} = {}) => {
  if (!runId) throw new Error('runId is required');
  const { data } = await axios.post(`${BASE_URL}/runs/${encoded(runId)}/variances/reset-reviews`, cleanParams({
    varianceIds,
    bacs,
    all,
  }));
  return data;
};
